import { apiRequest } from "../util/apiUtils";

export const applicationAddTitle = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.formId ? "put" : "post",
      `application-form/${payload?.formId ? "edit-form" : "add-form"}`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationList = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/form-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const appFormDelete = async (payload) => {
  try {
    const res = await apiRequest("patch", `application-form/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const applicationDetails = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/details`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const dynamicFieldManage = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `application-form/field-manage`,
      {
        body: payload,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const dynamicFieldDelete = async (payload) => {
  try {
    const res = await apiRequest("post", `application-form/field-delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

//////////////////////front api

export const scholarShipApply = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `application-form/form-submission`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const stepList = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/step-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const globalStepsList = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/global-step-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const resumeStepDetails = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/resumed-code`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const editStepLabel = async (payload) => {
  try {
    const res = await apiRequest("put", `application-form/update-groupcode`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const submissionData = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/download-form`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const appFormStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `application-form/status-change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
